/* eslint-disable no-console */

import { register } from 'register-service-worker'

const STALE_WORKER_RELOAD_KEY = 'dream:stale-worker-reload'

if (process.env.NODE_ENV === 'production') {
  const hadController = Boolean(navigator.serviceWorker.controller)
  let refreshing = false

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hadController || refreshing) {
      return
    }

    refreshing = true
    window.location.reload()
  })

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated () {
      console.log('New content is available; refreshing automatically.')
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
} else if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then(async (registrations) => {
      const hadController = Boolean(navigator.serviceWorker.controller)
      const results = await Promise.all(
        registrations
          .filter(({ scope }) => scope.startsWith(window.location.origin))
          .map((registration) => registration.unregister())
      )
      const removedWorker = results.some(Boolean)

      if (
        hadController &&
        removedWorker &&
        sessionStorage.getItem(STALE_WORKER_RELOAD_KEY) !== '1'
      ) {
        sessionStorage.setItem(STALE_WORKER_RELOAD_KEY, '1')
        window.location.reload()
        return
      }

      sessionStorage.removeItem(STALE_WORKER_RELOAD_KEY)
    })
    .catch((error) => {
      console.error('Failed to clear a stale development service worker:', error)
    })
}